"use client";

import { CopyableContent } from "@/src/components/copyable-content";
import { tryGetEhrSystemId } from "@/src/lib/resolve-ehr-ids";
import { EHRDocument } from "@/src/models/ehr-document";
import { Patient } from "@/src/models/patient";
import { getPersonName } from "@/src/models/person";

interface AthenaPatientInfoHeaderProps {
  title: string;
  patientDetails: Patient | null;
  document: EHRDocument | null;
  documentPatientId?: string | null;
}

export function AthenaPatientInfoHeader({
  title,
  patientDetails,
  document,
  documentPatientId,
}: AthenaPatientInfoHeaderProps) {
  return (
    <div className="mb-4">
      <h3 className="text-md font-semibold text-center mb-2">{title}</h3>
      <div className="grid grid-cols-3">
        <div>
          <span className="font-medium">Patient Name: </span>{" "}
          <CopyableContent text={getPersonName(patientDetails, true, true) || "N/A"} />
        </div>
        <div>
          <span className="font-medium">EHR ID: </span>
          <CopyableContent text={(patientDetails && tryGetEhrSystemId(patientDetails)) || "N/A"} />
        </div>
        <div>
          <span className="font-medium">Document ID: </span>
          <CopyableContent text={document?.ehrId || "N/A"} />
        </div>
      </div>
      {documentPatientId && (
        <div className="mt-1">
          <span className="font-medium">EHR ID attached to document: </span>
          <CopyableContent text={documentPatientId} />
        </div>
      )}
    </div>
  );
}
